import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import Handlebars from 'handlebars';
import 'dhtmlxMessage';
import ProgressTemplate from 'text-loader!../../js/templates/progress.template.htm';
import i18n  from "l10n";
var trs = require('../../libs/assets/table_row_selection.js')

export default Backbone.View.extend({
	Template: null,
	template: null,
	myDomId: null,
	domain: null,
	options: {},
	progressTemplate : Handlebars.compile(ProgressTemplate),
	initialize: function () {
	},
	initializeTrs: function(callback, tableReference) {
	    trs.bindRowClick(".table-responsive tr", null);
	    trs.bindChangeEvents(".check", tableReference, callback);
	},
	showHideActionButton: function(flag, btn, tableReference) {
	    if(flag && $(btn).css('display') == 'none' )
            $(btn).show();
        else if ( $(tableReference).find("input:checked").length == 0  )
            $(btn).hide();
	},
	//Run method when user want to go one page back
	goBack: function()
	{
		//with this code we go to the previous page
		window.history.go(-1);
	},
	showFillProgressBar: function()
	{
		$("#progress").html(this.progressTemplate());
	},
	showActionProgressBar: function()
	{
		window.progressBarCounter = window.progressBarCounter + 1;

		$("#container-progress").css("display", "block");
		$("body").addClass("noScroll");
	},
	hideActionProgressBar: function()
	{
		window.progressBarCounter = window.progressBarCounter - 1;
		if(window.progressBarCounter < 0)
			window.progressBarCounter = 0;

		if(window.progressBarCounter == 0)
		{
			$("#container-progress").css("display", "none");
			$("body").removeClass("noScroll");
		}
	},
	privilegeLevelToNumber: function(privilegeLevel)
	{
		if(privilegeLevel == "SupervisingAdmin")
		{
			return 0;
		}else if(privilegeLevel == "OrganizationAdmin")
		{
			return 1;
		}else if(privilegeLevel == "VenueAdmin")
		{
			return 2;
		}else if(privilegeLevel == "VenueAgent")
		{
 			return 3;
		}

		return -1;
	},
	numberToPrivilegeLevel: function(number)
	{

		switch(Number(number))
		{
			case 0:
				return "SupervisingAdmin";
			case 1:
				return "OrganizationAdmin";
			case 2:
				return "VenueAdmin";
			case 3:
				return "VenueAgent";

		}

		return null;

	},
	changeTitle: function(title)
	{
		document.title = title+" | Qedis";
	},
	isEmpty: function(element, self) {
		if(!self) self = this;

	    // also passing the type, because there are some textareas
		element = $(element);

        var errorSpan = element.parent().prop('tagName') == "FORM" ? element.parent() : element;

		if(element.find("input").val().trim() == "")
		{
            self.setError(errorSpan, i18n.t("account.empty_field"));
            return true;
		}
		else
		{
			self.clearError(element);
			return false;
		}
  	},
  	noSpaces: function(element, self) {
        if(!self) self = this;

        // also passing the type, because there are some textareas
        element = $(element);

        var errorSpan = element.parent().prop('tagName') == "FORM" ? element.parent() : element;

        if(element.find("input").val().indexOf(" ") > -1)
        {
            self.setError(errorSpan, i18n.t("account.no_spaces"));
            return true;
        }
        else
        {
            self.clearError(element);
            return false;
        }
    },
  	isNotNumeric: function(element, self) {
		if(!self) self = this;
		element = $(element);

		if(element.find("input").val().trim() != "")
		{
			if(isNaN(Number(element.find("input").val().trim())))
			{
				self.setError(element, i18n.t("account.invalid_number"));
				return true;
			}
		}

		self.clearError(element);
		return false;
    },
  	ignoreEmpty: function(element, self) {
		if(!self) self = this;

		element = $(element);
		var errorSpan = element.parent().prop('tagName') == "FORM" ? element.parent() : element;

		if(element.find("input").val().trim() == "")
		{
			self.clearError(element);
			return true;
		}

		return false;
	},
  	isNotDate: function(element, self)
  	{
  		if(!self) self = this;
  		element = $(element);

		var temp = Date.parse(element.find('input').val());
		//console.info(temp);
		if(isNaN(temp))
		{
			self.setError(element, i18n.t("account.invalid_date"));
			return true;
		}

		self.clearError(element);
		return false;

  	},
  	isNoValidPassword: function(element , self)
	{
		if(!self) self = this;
			element = $(element);

		var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).{6,}/;

		if(re.test(element.find("input").val()))
		{
			self.clearError(element);
			return false;
		}
		else
		{
			self.setError(element,  i18n.t("account.pswd_prompt"));
			return true;
		}
	},
  	minLengthNumber: function(element, self)
  	{
		if(!self) self = this;
		element = $(element);
		var minLength = element.data("min-length");
		if( !minLength ) throw 'You must declare at the parent div the data-min-length';

		if(element.find("input").val().length < minLength)
		{
			self.setError(element, i18n.t("account.min_length")+" " + minLength +" "+i18n.t("account.characters"));
			return true;
		}
		else
		{
			self.clearError(element);
			return false;
		}
  	},
  	maxLengthNumber: function(element, self)
  	{
		if(!self) self = this;
		element  = $(element);
		var maxLength = element.data("max-length");
		if( !maxLength ) throw 'You must declare at the parent div the data-max-length';

		var type = "input";
		if(element.data("type"))
			type = element.data("type");

		if(element.find(type).val().length >= maxLength)
		{
			self.setError(element, i18n.t("account.max_length")+" " + maxLength  +" "+i18n.t("account.characters"));
			return true;
		}
		else
		{
			self.clearError(element);
			return false;
		}
  	},
  	isEmail: function(element, self) {
		if(!self) self = this;

		element = $(element);
		var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if(!regex.test(element.find("input").val()))
		{
            self.setError(element, i18n.t("account.invalid_email"));
            return true;
		}else
		{
            self.clearError(element);
            return false;
		}
	},
	isPhone: function(element, self) {
		if(!self) self = this;

        element = $(element);
        var regex1 = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
        var regex2 = /\(?([0-9]{4})\)?([ .-]?)([0-9]{3})\2([0-9]{3})/;

        if(!regex1.test(element.find("input").val()) && !regex2.test(element.find("input").val()))
        {
            self.setError(element, i18n.t("account.invalid_phone"));
            return true;
        }
        else
        {
            self.clearError(element);
            return false;
        }
    },
    sameValues: function(element, self)
    {
		if(!self) self = this;

        element = $(element);
        var element_to_confirm = $(element.data("compare-with"));
        if( !element_to_confirm ) throw 'You must declare at the parent div the data-compare-with';

        if(element.find("input").val() != element_to_confirm.find("input").val())
        {
            self.setError(element, i18n.t("account.pswds_not_match"));
            return true;
        }
        else
        {
            self.clearError(element);
            return false;
        }
    },
    isLessThan: function(element, self)
    {
		if(!self) self = this;

        var element = $(element);
        var element_to_evaluate = $(element.data("evaluate-with"));
        if( !element_to_evaluate ) throw 'You must declare at the parent div the data-evaluate-with';

        if(Number(element.find("input").val()) <= Number(element_to_evaluate.find("input").val()))
        {
            self.setError(element, i18n.t(element.data("eval-msg")));
            return true;
        }
        else
        {
            self.clearError(element);
            return false;
        }
    },
	isNotSelect: function(element, self)
	{
		if(!self) self = this;

		element = $(element);

		if(element.find("select").val() == null)
		{
			self.setError(element, i18n.t("advance_options.select_item"));
			return true;
		}
		else
		{
			self.clearError(element);
			return false;
		}
	},
	characterLeft: function(elementTag)
	{
 		var element = $(elementTag);
        var maxLength = element.data("max-length");
        var length = element.find("textarea").val().trim().length;
        var diff = maxLength-length;
        element.find("span#char_counter").html(diff+"");

        var maxLength = element.data("max-length");
        if(diff < 0)
        {
            this.setError(element, i18n.t("account.max_length")+" " + maxLength +" "+i18n.t("account.characters"));
            return true;
        }

        this.clearError(element);
        return false;
	},
	setError: function(element, error_msg)
	{
        if((typeof element) == "string")
        	element = $(element);

        // finds the correct div, in order to addClass 'has-error'
        var errorDiv = element.prop('tagName') == "FORM" ? element.parent() : element;
        errorDiv.addClass("has-error");
        errorDiv.find("span.error-block").text(error_msg);
	},
	clearError: function(element)
	{
	 	if((typeof element) == "string")
			element = $(element);
	    // finds the correct div, in order to removeClass 'has-error'
	    var errorDiv = element.parent().prop('tagName') == "FORM" ? element.parent().parent() : element;

        // problem with implementation
		errorDiv.removeClass("has-error");
		errorDiv.find("span.error-block").text("");
	},
	validateFields: function(fields)
	{
		var has_error = false;
		var keys = Object.keys(fields);

        for(var i = 0; i < keys.length; i++)
        {
			//console.info(keys[i]);
            var validations = fields[keys[i]];
            for(var k = 0; k < validations.length; k++)
            {
                if(typeof keys[i] === "function")
                    keys[i](); //toDO;
                else if(validations[k]('#'+keys[i], this))
                {
                    has_error = true;
                    break;
                }
            }
        }
		return has_error;
	},
	onlyNumbers: function(event)
	{
		var KeyID = event.charCode;
		var temp = event.keyCode;
		switch(KeyID == 0 ? temp : KeyID)
		{
			case 8:
			case 9:
			case 46:
			case 48:
			case 49:
			case 50:
			case 51:
			case 52:
			case 53:
			case 54:
			case 55:
			case 56:
			case 57:
			return true;


		}
		return false;

	},
	onDataHandler: function(collection, response, options) {
  	},
    onErrorHandler: function(collection, xhr, options) {
		document.cookie = "status=" + xhr.status;
		if (xhr.status == 401) {
			window.open('./','_self');
		}else if(xhr.status == 403){
			$.ajaxq.abort("DefaultQueue");
			window.open('./','_self');
		}
  	},
  	getTodayWithOffset: function(dayOffset) {
        var today = new Date();
        today.setDate(today.getDate() - dayOffset);

        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();

        if(dd < 10) {
            dd = '0' + dd
        }

        if(mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd;

        return today;
    },
    reEvaluate: function(element, self, callback) {
        if(!self) self = this;

        element_to_reevaluate = $(element.data("reevaluate-field"));
        if( !element_to_reevaluate )
            return;

        return callback(element_to_reevaluate, self);
    },
});

